export default __webpack_public_path__ + "static/media/dota2.a0912191.jpg";